/**
 * Static navigation indexes for admin / vendor global search.
 * Keywords include aliases (e.g. "orders" → bookings).
 */

export const ADMIN_SEARCH_PAGES = [
  { id: 'home', label: 'Home', href: '/admin', group: 'Pages', keywords: ['home', 'start'] },
  { id: 'dashboard', label: 'Dashboard', href: '/admin/dashboard', group: 'Pages', keywords: ['metrics', 'pulse', 'overview', 'stats'] },
  { id: 'clients', label: 'Clients', href: '/admin/clients', group: 'People', keywords: ['customers', 'users'] },
  { id: 'vendors', label: 'Vendors', href: '/admin/vendors', group: 'People', keywords: ['sellers', 'verification'] },
  { id: 'bookings', label: 'Bookings', href: '/admin/bookings', group: 'Marketplace', keywords: ['orders', 'events', 'jobs'] },
  { id: 'calendar', label: 'Booking calendar', href: '/admin/bookings/calendar', group: 'Marketplace', keywords: ['schedule', 'calendar'] },
  { id: 'services', label: 'Vendor services', href: '/admin/services', group: 'Marketplace', keywords: ['listings', 'offers'] },
  { id: 'categories', label: 'Service categories', href: '/admin/service-categories', group: 'Marketplace', keywords: ['categories'] },
  { id: 'countries', label: 'Countries', href: '/admin/countries', group: 'Marketplace', keywords: ['geo'] },
  { id: 'markets', label: 'Markets', href: '/admin/markets', group: 'Marketplace', keywords: ['regions', 'bookable'] },
  { id: 'accounting', label: 'Accounting', href: '/admin/accounting', group: 'Finance', keywords: ['ledger', 'books'] },
  { id: 'payments', label: 'Payments', href: '/admin/payments', group: 'Finance', keywords: ['money', 'stripe', 'deposits'] },
  { id: 'refunds', label: 'Refunds', href: '/admin/refunds', group: 'Finance', keywords: ['chargeback'] },
  { id: 'subscriptions', label: 'Subscriptions', href: '/admin/subscriptions', group: 'Finance', keywords: ['plans'] },
  { id: 'subscription-payments', label: 'Subscription payments', href: '/admin/subscription-payments', group: 'Finance', keywords: ['billing'] },
  { id: 'payouts', label: 'Vendor payouts', href: '/admin/vendor-payouts', group: 'Finance', keywords: ['disbursements', 'transfers'] },
  { id: 'tax-reports', label: 'Tax reports', href: '/admin/marketplace-tax-reports', group: 'Finance', keywords: ['tax', 'vat'] },
  { id: 'analytics', label: 'Analytics', href: '/admin/analytics', group: 'Insights', keywords: ['charts', 'reports'] },
  { id: 'advanced-analytics', label: 'Advanced analytics', href: '/admin/advanced-analytics', group: 'Insights', keywords: [] },
  { id: 'reports', label: 'Reports', href: '/admin/reports', group: 'Insights', keywords: [] },
  { id: 'revenue', label: 'Revenue', href: '/admin/revenue', group: 'Insights', keywords: ['gmv'] },
  { id: 'performance', label: 'Performance', href: '/admin/performance', group: 'Insights', keywords: [] },
  { id: 'failed-ops', label: 'Failed operations', href: '/admin/failed-operations', group: 'Insights', keywords: ['errors'] },
  { id: 'content', label: 'Content', href: '/admin/content', group: 'Content', keywords: ['cms'] },
  { id: 'blog', label: 'Blog posts', href: '/admin/blog-posts', group: 'Content', keywords: ['articles'] },
  { id: 'press', label: 'Press releases', href: '/admin/press-releases', group: 'Content', keywords: [] },
  { id: 'jobs', label: 'Job postings', href: '/admin/job-postings', group: 'Content', keywords: ['careers'] },
  { id: 'spotlight', label: 'Vendor spotlight', href: '/admin/vendor-spotlight', group: 'Content', keywords: [] },
  { id: 'stories', label: 'Success stories', href: '/admin/vendor-success-stories', group: 'Content', keywords: [] },
  { id: 'support', label: 'Support tickets', href: '/admin/support-tickets', group: 'Engage', keywords: ['help', 'tickets'] },
  { id: 'reviews', label: 'Reviews', href: '/admin/reviews', group: 'Engage', keywords: ['ratings'] },
  { id: 'messages', label: 'Messages', href: '/admin/messages', group: 'Engage', keywords: ['chat', 'inbox'] },
  { id: 'contact', label: 'Contact inbox', href: '/admin/contact-messages', group: 'Engage', keywords: ['contact'] },
  { id: 'notifications', label: 'Notifications', href: '/admin/notifications', group: 'Engage', keywords: ['alerts'] },
  { id: 'announcements', label: 'Announcements', href: '/admin/announcements', group: 'Engage', keywords: ['broadcast'] },
  { id: 'faqs', label: 'FAQ', href: '/admin/faqs', group: 'Engage', keywords: ['faq', 'help'] },
  { id: 'handbook', label: 'Platform handbook', href: '/admin/handbook', group: 'Platform', keywords: ['docs'] },
  { id: 'settings', label: 'Settings', href: '/admin/settings', group: 'Platform', keywords: ['config'] },
  { id: 'email-templates', label: 'Email templates', href: '/admin/email-templates', group: 'Platform', keywords: ['mail'] },
  { id: 'security', label: 'Security', href: '/admin/security', group: 'Platform', keywords: [] },
  { id: 'logs', label: 'System logs', href: '/admin/system-logs', group: 'Platform', keywords: ['logs'] },
  { id: 'audit', label: 'Audit trail', href: '/admin/audit-trail', group: 'Platform', keywords: ['audit'] },
  { id: 'compliance', label: 'Compliance', href: '/admin/compliance', group: 'Platform', keywords: [] },
  { id: 'terms', label: 'Terms of service', href: '/admin/terms-of-service', group: 'Platform', keywords: ['tos'] },
  { id: 'privacy', label: 'Privacy policy', href: '/admin/privacy-policy', group: 'Platform', keywords: ['gdpr'] },
];

export const VENDOR_SEARCH_PAGES = [
  { id: 'home', label: 'Home', href: '/vendor', group: 'Pages', keywords: ['home', 'start', 'setup'] },
  { id: 'dashboard', label: 'Dashboard', href: '/vendor/dashboard', group: 'Pages', keywords: ['metrics', 'overview', 'stats'] },
  { id: 'account', label: 'Account', href: '/vendor/account', group: 'Business', keywords: ['profile', 'business'] },
  { id: 'profile', label: 'Profile preview', href: '/vendor/profile', group: 'Business', keywords: ['public'] },
  { id: 'verification', label: 'Verification', href: '/vendor/verification', group: 'Business', keywords: ['verify', 'identity', 'kyc'] },
  { id: 'services', label: 'Services', href: '/vendor/services', group: 'Services', keywords: ['listings', 'offers'] },
  { id: 'packages', label: 'Packages', href: '/vendor/packages', group: 'Services', keywords: ['bundles'] },
  { id: 'bookings', label: 'Internal bookings', href: '/vendor/bookings', group: 'Internal', keywords: ['orders', 'events', 'jobs', 'requests', 'platform', 'marketplace'] },
  { id: 'consultations', label: 'Leads', href: '/vendor/consultations', group: 'Internal', keywords: ['calls', 'meetings', 'consultations', 'follow-up', 'kanban', 'board', 'pipeline', 'questionnaire', 'consultation form'] },
  { id: 'consultation-form', label: 'Consultation form', href: '/vendor/consultations?settings=form', group: 'Internal', keywords: ['questionnaire', 'book consultation', 'questions', 'preferences'] },
  { id: 'external-lead-board', label: 'External leads', href: '/vendor/external-leads', group: 'External', keywords: ['kanban', 'drag', 'pipeline', 'checklist', 'share link', 'follow-up'] },
  { id: 'accounting', label: 'Accounting', href: '/vendor/accounting', group: 'Internal', keywords: ['ledger', 'marketplace'] },
  { id: 'earnings', label: 'Earnings', href: '/vendor/earnings', group: 'Internal', keywords: ['income'] },
  { id: 'payments', label: 'Payments', href: '/vendor/payments', group: 'Internal', keywords: ['stripe', 'deposits'] },
  { id: 'discounts', label: 'Discount codes', href: '/vendor/discount-codes', group: 'Internal', keywords: ['coupons', 'promo'] },
  { id: 'payouts', label: 'Payouts', href: '/vendor/payout-disbursements', group: 'Internal', keywords: ['transfers', 'withdraw'] },
  { id: 'tax', label: 'Payout / tax profile', href: '/vendor/tax-profile', group: 'Internal', keywords: ['stripe connect', 'tax'] },
  { id: 'internal-dashboard', label: 'Internal dashboard', href: '/vendor/dashboard', group: 'Internal', keywords: ['marketplace', 'metrics', 'earnings'] },
  { id: 'internal-invoices', label: 'Internal invoices', href: '/vendor/internal-invoices', group: 'Internal', keywords: ['platform client', 'billing', 'marketplace'] },
  { id: 'external-overview', label: 'External overview', href: '/vendor/external', group: 'External', keywords: ['off-platform', 'private', 'own clients'] },
  { id: 'external-leads', label: 'External leads', href: '/vendor/external-leads', group: 'External', keywords: ['lead', 'share link', 'inquiry', 'whatsapp', 'instagram', 'off-platform'] },
  { id: 'private-bookings', label: 'Private bookings', href: '/vendor/private-bookings', group: 'External', keywords: ['manual', 'offline', 'external'] },
  { id: 'invoices', label: 'External invoices', href: '/vendor/invoices', group: 'External', keywords: ['billing', 'guest', 'external'] },
  { id: 'contracts', label: 'Contracts', href: '/vendor/contracts', group: 'External', keywords: ['agreements', 'signing'] },
  { id: 'workspace', label: 'Workspace', href: '/vendor/workspace', group: 'Schedule', keywords: ['todo', 'todos', 'meeting', 'meetings', 'tasks', 'schedule', 'daily', 'board', 'kanban'] },
  { id: 'automations', label: 'Automations', href: '/vendor/automations', group: 'Schedule', keywords: ['automation', 'recipes', 'workflow'] },
  { id: 'integrations', label: 'Integrations', href: '/vendor/integrations', group: 'Schedule', keywords: ['whatsapp', 'excel', 'sheets', 'agents', 'connect'] },
  { id: 'calendar', label: 'Calendar', href: '/vendor/calendar', group: 'Schedule', keywords: ['schedule'] },
  { id: 'portfolio', label: 'Portfolio', href: '/vendor/portfolio', group: 'Showcase', keywords: ['work', 'photos'] },
  { id: 'gallery', label: 'Photo gallery', href: '/vendor/gallery', group: 'Showcase', keywords: ['images'] },
  { id: 'branding', label: 'Custom branding', href: '/vendor/branding', group: 'Showcase', keywords: ['logo', 'brand'] },
  { id: 'analytics', label: 'Analytics', href: '/vendor/analytics', group: 'Insights', keywords: ['charts'] },
  { id: 'advanced-analytics', label: 'Advanced analytics', href: '/vendor/advanced-analytics', group: 'Insights', keywords: [] },
  { id: 'performance', label: 'Performance', href: '/vendor/performance', group: 'Insights', keywords: [] },
  { id: 'reports', label: 'Reports', href: '/vendor/reports', group: 'Insights', keywords: [] },
  { id: 'subscription', label: 'Plans & pricing', href: '/vendor/subscription', group: 'Plan', keywords: ['plans', 'upgrade'] },
  { id: 'my-subscription', label: 'My subscription', href: '/vendor/my-subscription', group: 'Plan', keywords: ['plan'] },
  { id: 'support-tickets', label: 'Priority support', href: '/vendor/support-tickets', group: 'Plan', keywords: ['tickets'] },
  { id: 'advanced-bookings', label: 'Advanced booking', href: '/vendor/advanced-bookings', group: 'Plan', keywords: [] },
  { id: 'locations', label: 'Multi-location', href: '/vendor/locations', group: 'Plan', keywords: ['locations', 'cities'] },
  { id: 'notifications', label: 'Notifications', href: '/vendor/notifications', group: 'Inbox', keywords: ['alerts'] },
  { id: 'reviews', label: 'Reviews', href: '/vendor/reviews', group: 'Inbox', keywords: ['ratings'] },
  { id: 'support', label: 'Support', href: '/vendor/support', group: 'Inbox', keywords: ['help'] },
  { id: 'security', label: 'Security', href: '/vendor/security', group: 'Settings', keywords: ['password', '2fa'] },
  { id: 'preferences', label: 'Preferences', href: '/vendor/preferences', group: 'Settings', keywords: ['settings'] },
];

/** Quick actions — navigate to create / priority workflows */
export const ADMIN_SEARCH_ACTIONS = [
  {
    id: 'action-vendors',
    label: 'Review vendor verifications',
    href: '/admin/vendors',
    keywords: ['approve', 'verify', 'pending', 'kyc'],
  },
  {
    id: 'action-announcement',
    label: 'Create announcement',
    href: '/admin/announcements',
    keywords: ['broadcast', 'publish', 'new announcement'],
  },
  {
    id: 'action-ticket',
    label: 'Open support tickets',
    href: '/admin/support-tickets',
    keywords: ['help', 'triage', 'support'],
  },
  {
    id: 'action-markets',
    label: 'Manage markets',
    href: '/admin/markets',
    keywords: ['activate', 'country', 'region'],
  },
  {
    id: 'action-payouts',
    label: 'Review vendor payouts',
    href: '/admin/vendor-payouts',
    keywords: ['disburse', 'transfer', 'money'],
  },
  {
    id: 'action-bookings',
    label: 'Monitor bookings',
    href: '/admin/bookings',
    keywords: ['orders', 'events'],
  },
];

export const VENDOR_SEARCH_ACTIONS = [
  {
    id: 'action-workspace',
    label: 'Open Workspace',
    href: '/vendor/workspace',
    keywords: ['todo', 'meeting', 'today', 'tasks', 'daily', 'board'],
  },
  {
    id: 'action-automations',
    label: 'Open Automations',
    href: '/vendor/automations',
    keywords: ['recipes', 'workflow', 'whatsapp', 'automation'],
  },
  {
    id: 'action-invoice',
    label: 'Create invoice',
    href: '/vendor/invoices/create',
    keywords: ['new invoice', 'bill', 'billing'],
  },
  {
    id: 'action-contract',
    label: 'Create contract',
    href: '/vendor/contracts/create',
    keywords: ['new contract', 'agreement', 'sign'],
  },
  {
    id: 'action-external-leads',
    label: 'Create external lead link',
    href: '/vendor/external-leads',
    keywords: ['share link', 'inquiry', 'lead', 'whatsapp', 'instagram'],
  },
  {
    id: 'action-private-booking',
    label: 'Add external private booking',
    href: '/vendor/private-bookings',
    keywords: ['manual', 'offline', 'new booking', 'external'],
  },
  {
    id: 'action-service',
    label: 'Manage services',
    href: '/vendor/services',
    keywords: ['new service', 'listing', 'package'],
  },
  {
    id: 'action-portfolio',
    label: 'Update portfolio',
    href: '/vendor/portfolio',
    keywords: ['photos', 'gallery', 'work'],
  },
  {
    id: 'action-connect',
    label: 'Set up payouts',
    href: '/vendor/tax-profile',
    keywords: ['stripe', 'connect', 'payout', 'tax'],
  },
];

export function filterSearchPages(pages, query) {
  const q = String(query || '').trim().toLowerCase();
  if (!q) return pages.slice(0, 8);
  return pages
    .filter((page) => {
      const hay = [page.label, page.group, page.href, ...(page.keywords || [])]
        .join(' ')
        .toLowerCase();
      return hay.includes(q);
    })
    .slice(0, 12);
}

export function filterSearchActions(actions, query) {
  const q = String(query || '').trim().toLowerCase();
  if (!q) return actions.slice(0, 4);
  return actions
    .filter((action) => {
      const hay = [action.label, action.href, ...(action.keywords || [])]
        .join(' ')
        .toLowerCase();
      return hay.includes(q);
    })
    .slice(0, 6);
}
